import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import naja from "naja";
import Form from "./Form";

export default class Filter {

    static init() {
        this.initFilterForm();
        this.handleFiltersUpdate();
        this.handleToggleLoadMore();

        const toggle = document.getElementById('filterToggle');
        const container = document.getElementById('filterContainer');
        const category = document.getElementById('categoryFilter');
        const closer = document.getElementById('filterCloser');

        if (toggle && container && category) {
            // toggle open filter container (container element) on mobile devices
            toggle.addEventListener('click', e => {
                e.preventDefault();
                if (window.matchMedia('(max-width: 1279px)').matches) {
                    disableBodyScroll(category);
                }
                toggle.classList.toggle('open');
                container.classList.toggle('category-filter-container--open');
            });
            // init closer of filter container
            closer.addEventListener('click', e => {
                e.preventDefault();
                if (window.matchMedia('(max-width: 1279px)').matches) {
                    enableBodyScroll(category);
                }
                container.classList.remove('category-filter-container--open');
            });
            // set mobile filter behaviour
            Filter.handleMobile();
        }

    }

    static handleMobile() {
        const items = document.querySelectorAll('.jsCategoryFilterItem');

        if (items.length > 0) {
            items.forEach(item => {
                // get header to find out if is open on init (default, on page load)
                let header = item.querySelector('.jsAccordionHeader');
                // if header contains category-filter__header--open -> the filter item has to be open
                if (header.classList.contains('category-filter__header--open')) {
                    item.classList.add('category-filter__item--open');
                }

                // handle open/close filter item on click by toggling category-filter__item--open class
                item.addEventListener('click', () => {
                    // if filter has the class when user click on it, we want to close this filter
                    let closeThisItem = item.classList.contains('category-filter__item--open');
                    if (closeThisItem) {
                        item.classList.remove('category-filter__item--open');
                    } else {
                        item.classList.add('category-filter__item--open');
                    }
                    /*
                    hide siblings when this item is active - with current functionality useless:

                    let siblings = Helpers.getSiblings(item);
                    siblings.forEach(sibling => {
                        sibling.classList.toggle('category-filter__item--inactive');
                    });
                     */
                });
            })
        }
    }

    static initFilterForm() {
        const formInputs = document.querySelectorAll('#frm-productFilter-filterForm input');

        if (formInputs.length > 0) {
            formInputs.forEach(input => {
                if(input.type === 'checkbox') {
                    let clone = input.cloneNode(true);
                    input.parentNode.replaceChild(clone, input);
                    clone.addEventListener('change', () => {
                        naja.uiHandler.submitForm(document.querySelector('#frm-productFilter-filterForm'));
                    })
                }
            })
        }
    }

    static handleFiltersUpdate() {
        const productsContainer = document.getElementById('snippet--products');

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--categoryList-priceFilter') {
                Form.slider();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id.includes('snippet-productFilter')) {
                this.initFilterForm();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id.includes('snippet-priceFilter-price')) {
                Form.slider();
            }
        });

        const form = document.getElementById('frm-productFilter-filterForm');
        const formPrice = document.getElementById('frm-priceFilter-priceForm');
        if(form) {
            naja.addEventListener('complete', (event) => {
                form.action = event.detail.payload.url;
            });
        }
        if(formPrice) {
            naja.addEventListener('complete', (event) => {
                formPrice.action = event.detail.payload.url;
            });
        }

        if(productsContainer) {
            naja.snippetHandler.addEventListener('afterUpdate', (event) => {
                if (event.detail.snippet.id === 'snippet--btnNext') {
                    productsContainer.removeAttribute('data-naja-snippet-append');
                    this.handleToggleLoadMore();
                }
            });
        }
    }

    static handleToggleLoadMore() {
        let toggle = document.getElementById('load-more-button');
        let productsContainer = document.getElementById('snippet--products');

        if(toggle && productsContainer) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                productsContainer.setAttribute('data-naja-snippet-append', true);
            })
        }

    }
}
